import { connect } from 'react-redux';
import CoreLayout from './CoreLayout';
import { reset } from 'reducers/reset';
import { loadLocale } from 'reducers/locale';
import { loadSettings } from 'reducers/settings';

const mapDispatchToProps = {
  reset,
  loadLocale,
  loadSettings
};

const mapStateToProps = (state) => ({
  locale: state.locale,
  settings: state.settings
});

export default connect(mapStateToProps, mapDispatchToProps)(CoreLayout);
